module.exports = __webpack_public_path__ + "img/9788958280934.b02b5356.jpg";